module.exports = __webpack_public_path__ + "img/share.3229e80f.jpg";